import apiService from "../api";

export const getVaccineRecommedation = () => {
  return apiService("/vaccine-recommendations/", "GET", null, true);
};
